import { render, staticRenderFns } from "./internal_permission.vue?vue&type=template&id=9919c858&scoped=true&"
import script from "./internal_permission.vue?vue&type=script&lang=js&"
export * from "./internal_permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9919c858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9919c858')) {
      api.createRecord('9919c858', component.options)
    } else {
      api.reload('9919c858', component.options)
    }
    module.hot.accept("./internal_permission.vue?vue&type=template&id=9919c858&scoped=true&", function () {
      api.rerender('9919c858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/tabs/internal_permission.vue"
export default component.exports